// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OKzs","top":"styles_top__2KzW7"};